import { useEffect, useState } from "preact/hooks";
import type { IndexRecord, Manifest } from "../../shared/snapshot-format";
import { loadCatalogue } from "../data/catalogue";
import { loadManifest } from "../data/manifest";
import { loadSearch, type Search } from "../data/search";

/** The catalogue once loaded; undefined while loading, [] when it failed. */
export function useCatalogue(): IndexRecord[] | undefined {
  const [records, setRecords] = useState<IndexRecord[]>();
  useEffect(() => {
    loadCatalogue().then(setRecords, () => setRecords([]));
  }, []);
  return records;
}

/** The prebuilt search once loaded; null until then (callers fall back to name matching). */
export function useSearch(enabled = true): Search | null {
  const [search, setSearch] = useState<Search | null>(null);
  useEffect(() => {
    if (!enabled) return;
    loadSearch().then(setSearch, () => setSearch(null));
  }, [enabled]);
  return search;
}

export function useManifest(): Manifest | undefined {
  const [manifest, setManifest] = useState<Manifest>();
  useEffect(() => {
    loadManifest().then(setManifest, () => undefined);
  }, []);
  return manifest;
}
